import api from "../axiosIntercepture";

export const refereshToken = async (refreshToken) => {
    try {
        const response = await api.post('auth/refresh-token', {refreshToken});
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}